<p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable
  class="mt-4 bg-transparent content rounded-md">
  <p-tablist class="flex flex-row">
    <p-tab *ngFor="let dossier of planningReviewDetails" [value]="dossier.ref"> {{ dossier.ref }} </p-tab>
  </p-tablist>

  <ng-container *ngFor="let dossier of planningReviewDetails">
    <p-tabpanel  [value]="dossier.ref" class="px-2">
      <sm-form-builder [formObject]="formObject"></sm-form-builder>
    </p-tabpanel>  </ng-container>
</p-tabs>

<p-dialog [(visible)]="visible" [closeOnEscape]="true" [dismissableMask]="true" [modal]="true" draggable="false"
  resizable="false" styleClass="w-[80vw]">
  <ng-template #header></ng-template>

  <ng-container *ngIf="activeDossier as d">
    <!-- PPM -->
    <sm-ppm-inspect-content-block *ngIf="d.type === 'PPM'" [id]="d.id" [version]="d.version" [meeting]="true"
      [downloadModel]="downloadSignedPpm">
    </sm-ppm-inspect-content-block>

    <!-- DAC -->
    <ng-container *ngIf="d.type === 'DAC'">
      <sm-dac-inspect-content-block [id]="d.id" [version]="d.version"></sm-dac-inspect-content-block>
    </ng-container>

    <!-- REPORT -->
    <ng-container *ngIf="d.type === 'REPORT'">
      <sm-report-inspect-content-block [id]="d.id" [version]="d.version"></sm-report-inspect-content-block>
    </ng-container>

    <!-- ADDITIVE -->
    <ng-container *ngIf="d.type === 'ADDITIF'">
      <sm-clarification-inspect-content-block [id]="d.id" [version]="d.version"></sm-clarification-inspect-content-block>
    </ng-container>
  </ng-container>
</p-dialog>
